import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';
import {ComputeWithMetaDataDto} from '@sharedrest/data.restservice';
import {UserService} from '@sharedcommon/services/user.service';
import {RawmaterialOrSampleService} from '@usercommon/service/rawmaterial-or-sample.service';
import {MatrixDto} from '@sharedrest/equation.restservice';
import { CalculationStatusService } from '@usercommon/service/calculation-status.service';
import { RawMaterialFacultativeErrorPopin } from '@usercommon/components/rawmaterials/rawmaterial-facultative-error-popin/rawmaterial-facultative-error-popin.component';
import {MatDialog} from '@angular/material/dialog';
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

@Component({
  selector: 'neq-rawmaterials-or-samples-manage',
  templateUrl: './rawmaterials-or-samples-manage.page.html'
})
export class NeqRawmaterialsOrSamplesManagePage implements OnInit, OnDestroy {

  public id: string;
  public matrices: MatrixDto[];
  public calculationId: string = null ;
  public tabIndex = 0;
  public isReadOnly = false;
  public computeWithMeta: ComputeWithMetaDataDto ;
  public valueHasBeenTouched: boolean;

  private subscription: Subscription;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly userService: UserService,
    private readonly rawmatOrSampleService: RawmaterialOrSampleService,
    private readonly dialogMat: MatDialog
  ) {
  }

  ngOnInit() {
    this.matrices = this.route.snapshot.data['matrices'];

    this.rawmatOrSampleService.clearValues(true);

    this.subscription = this.route.params.subscribe(params => {
      if (this.id && params['id'] !== this.id) {
        // unlock previous MP
        this.unlockRawMatIfNeeded() ;
        this.tabIndex = 0;
      }

      this.id = params['id'];
    });

    this.route.queryParams.subscribe(params => {
      this.calculationId = params['result'];
      const isComputeCalcStatusOk = !CalculationStatusService.isCalcStatusBlockedBeforeCalc(this.rawmatOrSampleService.getTempCalculationStatus()) ;
      this.tabIndex = (isComputeCalcStatusOk && this.calculationId) ? 1 : 0;
    });
  }

  onComputeChange(computeWithMeta: ComputeWithMetaDataDto): void {
    this.computeWithMeta = computeWithMeta ;
    if (this.computeWithMeta?.facultativeNutError) {
      this.showFacultativeErrorPopin() ;
    }
  }

  showFacultativeErrorPopin(): void {
    this.dialogMat.open(RawMaterialFacultativeErrorPopin, {
      data: {
        args: this.computeWithMeta,
      }
    });
  }

  setValueHasBeenTouched(newValue: boolean): void {
    this.valueHasBeenTouched = newValue;
  }

  /**
   * Unlock the raw material if we need it
   */
  unlockRawMatIfNeeded(): void {
    if (this.userService.getEntity() && !this.isReadOnly) {
      this.rawmatOrSampleService.patch(this.id, {patchAction: 'UNLOCK_ENTITY'})
        .subscribe(
          {
            error : (error: HttpErrorResponse) => {
              if (error.status === HttpStatusCode.Forbidden) {
                // Catch in case the user has waited on this page for a long period.
                // Long enough to make the raw material unlocked and let another user lock it.
                // Indeed the lock has an expiration time (currently it is 1 hour after the lock happened).
                // And if this case is happening then the http status is 403
                return ;
              }
              // Throw the error to get the http pop up
              throw error ;
            }
          });
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.unlockRawMatIfNeeded() ;
    /* Reset the flag when we will come back to the page */
    this.rawmatOrSampleService.setTempForcedCalcStatus(false) ;
    this.rawmatOrSampleService.setSaved(false);
  }

}
